
        var result = require("!!../../../../node_modules/css-loader/index.js!./payment-redirect.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/payment-redirect/payment-redirect.component.css
// module id = 624
// module chunks = 0